import { render, staticRenderFns } from "./SalesOrderStatusBadge.vue?vue&type=template&id=6218579e&"
import script from "./SalesOrderStatusBadge.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports